export class CidLookup {
    enhanced_licenses = "";
    classic_licenses = "";

    constructor(private licenses:string) { 
        const obj = JSON.parse(licenses);
        this.enhanced_licenses = obj.enhanced_licenses[0];
        this.classic_licenses = obj.classic_licenses[0];
    }
}
